import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { ShippingMethodPropertyMetadataResponse } from './shipping-method-property-metadata.response';
import { Nillable } from '@web/utils';
import { ShippingMethodPropertyCode } from '../../enums/shipping-method-property-code';

@jsonObject
export class ShippingMethodPropertyResponse {
  @jsonMember(String)
  public readonly code!: ShippingMethodPropertyCode;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly value!: string;

  @jsonArrayMember(ShippingMethodPropertyMetadataResponse)
  public readonly metadata?: Nillable<ShippingMethodPropertyMetadataResponse[]>;
}
